<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Dividenduitkeringen
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                <p>Vermeld de winstuitdelingen die onder de dividendbelasting vallen. Dit zijn bijvoorbeeld:</p>
                <ul>
                    <li>normale dividenden.</li>
                    <li>interimdividenden.</li>
                    <li>bonusaandelen uit de winst(reserves).</li>
                </ul>
            </div>
        </div>
    </div>
</div>
